var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BaseChip",attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),(_vm.showX)?_c('span',{key:"BC-x",staticClass:"BaseChip_X"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }